import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import { ContentInTooltip, formatDateAndTimeMeth2 } from '../../../Components/CommonFunctions/CommonFunctions'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { City, Country, State } from 'country-state-city';

const fieldLimits = {
    vendorName: 50,
    GSTIN: 15,
    DlNo1: 30,
    DlNo2: 30,
    DlNo3: 30,
    DlNo4: 30,
    DlNo5: 30,
    DlNo6: 30,
    mobileNum: 10,
    landline: 15,
    emailId: 50,
    address1: 50,
    address2: 50,
    areaName: 50,
    city: 50,
    stateName: 50,
    country: 50,
    pincode: 6,
};


const vendor_category = ['Consumable', 'Non Consumable']

export default function StoreVendor() {
    const [vendorList, setvendorList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [filtervendorCategory, setFilterVendorCategory] = useState('');
    const [formState, setFormState] = useState({
        vendorName: "",
        vendorCategory: "Consumable",
        GSTIN: "",
        DlNo1: "",
        DlNo2: "",
        DlNo3: "",
        DlNo4: "",
        DlNo5: "",
        DlNo6: "",
        mobileNum: "",
        landline: "",
        emailId: "",
        address1: "",
        address2: "",
        areaName: "",
        city: "",
        cityList: City.getCitiesOfState("IN", "TN"),
        stateName: "",
        country: "",
        state_code: "TN",
        country_code: "IN",
        pincode: "",
        AllCountry: Country.getAllCountries(),
        AllStates: State.getStatesOfCountry("IN"),
    });
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

    useEffect(() => {
        getVendorDetails()
    }, [])

    useEffect(() => {
        if (formState?.pincode?.length === 6) {
            getPincodeToCity(formState?.pincode);
        }
    }, [formState?.pincode])

    useEffect(() => {
        setFormState((prevState) => ({
            ...prevState,
            stateName: formState?.AllStates?.find((item) => (item.isoCode === formState?.state_code))?.name,
            country: formState?.AllCountry?.find((item) => (item.isoCode === formState?.country_code))?.name
        }))
    }, [formState?.pincode, formState?.city, formState?.state_code, formState?.country_code]);

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getVendorDetails = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_VENDOR + "?vendor_type=" + (filtervendorCategory === "Consumable" ? "consumables" : filtervendorCategory === "Non Consumable" ? "non-consumables" : ""))
                .then((response) => {
                    if (response.data.status === 'success') {
                        setvendorList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getPincodeToCity = (pincode) => {
        fetch("https://api.postalpincode.in/pincode/" + pincode)
            .then((res) => res.json())
            .then(response => {
                if (response && response[0].Status === "Success") {
                    const data = response[0].PostOffice;
                    if (data && data.length > 0) {
                        const Api_state = (data[0]?.State) === 'Pondicherry' ? 'Puducherry' : (data[0]?.State);
                        setFormState(prevState => ({
                            ...prevState,
                            city: prevState.city || data[0].District,
                            AllStates: prevState.state_code ? prevState.AllStates : State.getStatesOfCountry(Country.getAllCountries().find((item) => (item.name === data[0].Country))?.isoCode),
                            country_code: prevState.country_code || Country.getAllCountries().find((item) => (item.name === data[0].Country))?.isoCode,
                        }));
                        setFormState(prevState => ({
                            ...prevState,
                            state_code: prevState.state_code || prevState.AllStates.find((item) => (item.name === Api_state))?.isoCode,
                            cityList: prevState.city ? prevState.cityList : City.getCitiesOfState(prevState.country_code, prevState.AllStates.find((item) => (item.name === Api_state))?.isoCode)
                        }));
                    }
                }
            })
            .catch(e => {
                errorMessage(e.message)
            });
    };

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'vendorCategory':
                setFormState((prevState) => ({ ...prevState, "vendorCategory": val }));
                break
            case 'city':
                setFormState((prevState) => ({ ...prevState, "city": val?.name }));
                break
            case 'stateName':
                const cities = City.getCitiesOfState(formState.country_code, e.target.value) || [];
                setFormState((prevState) => ({
                    ...prevState,
                    "stateName": val,
                    "cityList": cities,
                    "city": "",
                }));
                break
            case 'country':
                setFormState((prevState) => ({
                    ...prevState,
                    "country": val,
                    "AllStates": State.getStatesOfCountry(e.target.value),
                    "city": "",
                    "cityList": []
                }));
                break

        }
    }

    const onChangeHandler = (e, name) => {
        const { value } = e.target;

        if (value === "" || value.length <= (fieldLimits[name] || 50)) {
            if (name === 'mobileNum' || name === 'pincode' || name === 'landline') {
                if (CommonValidation.numberOnly(value) || value === "") {
                    setFormState((prevState) => ({ ...prevState, [name]: value }));
                }
            } else if (name === "GSTIN") {
                if (CommonValidation.gstnumberValidation(value) || value === "") {
                    setFormState((prevState) => ({ ...prevState, [name]: value }));
                }
            } else {
                setFormState((prevState) => ({ ...prevState, [name]: value }));
            }
        }
    };


    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    value={val ? val : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width) => {
        return (
            <Box>
                <Autocomplete
                    size={'small'}
                    options={list}
                    name={name}
                    getOptionLabel={(option) => (typeof (option) === "string" ? option : (name === 'city' || name === 'stateName' || name === 'country') ? `${option?.name}` : option)}
                    value={val || null}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const TableHeaderBtns = () => {
        return (
            <Box>
                <Tooltip title="Filter" placement='top' arrow>
                    <IconButton onClick={() => { setFilterOpen(true) }}><FilterAltIcon color='primary' /></IconButton>
                </Tooltip>
            </Box>
        )
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText fromStore={true} isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} renderComponent={TableHeaderBtns} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = vendorList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        vendorList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'created_date', headerName: 'Registration Date', flex: 0.16,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.created_date ? formatDateAndTimeMeth2(params?.row?.created_date) : '-'}</Box>)

            },
            {
                field: 'vendor_name', headerName: 'Vendor Name', flex: 0.25,
                renderCell: (params) => (params.row.vendor_name ? params.row.vendor_name?.length > 35 ?
                    <Tooltip placement="top" title={params.row.vendor_name}><Typography fontSize={'0.9vw'}>{params.row.vendor_name?.slice(0, 35) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.vendor_name}</Typography> : '-')
            },
            {
                field: 'gst_no', headerName: 'GSTIN', flex: 0.14,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.gst_no ? params?.row?.gst_no : '-'}</Box>)

            },
            {
                field: 'dl_no', headerName: 'DL No', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.dl_no ? ContentInTooltip(params?.row?.dl_no, 15) : '-'}</Box>)

            },
            {
                field: 'mobile_number', headerName: 'Mobile Number', flex: 0.11,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.mobile_number ? params?.row?.mobile_number : '-'}</Box>)

            },
            {
                field: 'email', headerName: 'Email ID', flex: 0.21,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.email ? ContentInTooltip(params?.row?.email, 25) : '-'}</Box>)

            },
            // {
            //     field: 'is_active', headerName: 'Status', flex: 0.08,
            //     renderCell: (params) => (<Box component={'div'}>{params?.row?.is_active ? "Active" : 'InActive'}</Box>)

            // },
            {
                field: 'action', headerName: 'Action', flex: 0.05,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={delIDs?.length > 0}
                                onClick={() => {
                                    setFormState((prevState) => ({
                                        ...prevState,
                                        vendorName: params.row.vendor_name || "",
                                        vendorCategory: params.row?.vendor_category === "consumables" ? "Consumable" : "Non Consumable",
                                        GSTIN: params.row.gst_no || "",
                                        DlNo1: params.row.dl_no || "",
                                        DlNo2: params.row.dl_no_2 || "",
                                        DlNo3: params.row.dl_no_3 || "",
                                        DlNo4: params.row.dl_no_4 || "",
                                        DlNo5: params.row.dl_no_5 || "",
                                        DlNo6: params.row.dl_no_6 || "",
                                        mobileNum: params.row.mobile_number || "",
                                        landline: params.row.landline_number || "",
                                        emailId: params.row.email || "",
                                        address1: params.row.address_line_1 || "",
                                        address2: params.row.address_line_2 || "",
                                        areaName: params.row.area_name || "",
                                        city: params.row.city || "",
                                        stateName: params.row.state || "",
                                        country: params.row.country || "",
                                        pincode: params.row.pincode || "",
                                        country_code: Country.getAllCountries().find((item) => item.name === params.row.country)?.isoCode,
                                        AllStates: State.getStatesOfCountry(Country.getAllCountries().find((item) => item.name === params.row.country)?.isoCode),
                                        state_code: State.getStatesOfCountry(Country.getAllCountries().find((item) => item.name === params.row.country)?.isoCode).find((item) => item.name === params.row.state)?.isoCode,
                                    }));
                                    setIsActive(params.row.is_active)
                                    setEditID(params.row.id)
                                }} />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '41vh', marginTop: '.5vw' }}>
                <DataGrid
                    // checkboxSelection
                    // selectionModel={CheckBoxList}
                    // onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={vendorList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = (apicall = false) => {
        setFormState({
            vendorName: "",
            vendorCategory: "Consumable",
            GSTIN: "",
            DlNo1: "",
            DlNo2: "",
            DlNo3: "",
            DlNo4: "",
            DlNo5: "",
            DlNo6: "",
            mobileNum: "",
            landline: "",
            emailId: "",
            address1: "",
            address2: "",
            areaName: "",
            city: "",
            cityList: City.getCitiesOfState("IN", "TN"),
            stateName: "",
            country: "",
            state_code: "TN",
            country_code: "IN",
            pincode: "",
            AllCountry: Country.getAllCountries(),
            AllStates: State.getStatesOfCountry("IN"),
        })
        setEditID(null)
        setFilterOpen(false);
        setIsActive(true);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
        if(apicall){
            setTimeout(() => {
                getVendorDetails()
            }, 1000)
        }
    }

    const addVendorDetails = () => {
        try {
            if (!formState?.vendorName || !formState?.vendorCategory || !formState?.GSTIN || !formState?.DlNo1 || !formState?.mobileNum || !formState?.address1 || !formState?.areaName || !formState?.city || !formState?.pincode) {
                errorMessage('Please Enter All mandatory fields')
            } else if (formState?.mobileNum && formState?.mobileNum?.length !== 10) {
                errorMessage('Invalid Mobile Number')
            } else if (!CommonValidation.emailValidation(formState?.emailId) && formState?.emailId) {
                errorMessage('Invalid Email Id')
            } else if (formState?.GSTIN && formState?.GSTIN?.length !== 15) {
                errorMessage('Invalid GST Number')
            } else if (formState?.pincode && formState?.pincode?.length !== 6) {
                errorMessage('Invalid Pincode')
            } else {
                let data = {
                    'vendor_name': formState?.vendorName,
                    'vendor_category': formState?.vendorCategory === "Consumable" ? "consumables" : "non-consumables",
                    'gst_no': formState?.GSTIN,
                    'dl_no': formState?.DlNo1,
                    'dl_no_2': formState?.DlNo2,
                    'dl_no_3': formState?.DlNo3,
                    'dl_no_4': formState?.DlNo4,
                    'dl_no_5': formState?.DlNo5,
                    'dl_no_6': formState?.DlNo6,
                    'mobile_number': formState?.mobileNum,
                    'landline_number': formState?.landline,
                    'email': formState?.emailId,
                    'address_line_1': formState?.address1,
                    'address_line_2': formState?.address2,
                    'area_name': formState?.areaName,
                    'city': formState?.city,
                    'state': formState?.stateName,
                    'country': formState?.country,
                    'pincode': formState?.pincode,
                    'is_active': isActive,
                }
                if (EditID) {
                    data["id"] = EditID
                    RestAPIService.updateWithOutId(data, Serviceurls.STORE_VENDOR)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getVendorDetails()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                } else {
                    RestAPIService.create(data, Serviceurls.STORE_VENDOR)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getVendorDetails()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                }
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteVendor = () => {
        try {
            RestAPIService.delete(`${Serviceurls.STORE_VENDOR}?ids=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getVendorDetails()
                        closeFilter();
                        clearFunction()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={vendor_category}
                            value={filtervendorCategory}
                            onChange={(event, newValue) => {
                                setFilterVendorCategory(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Vendor Catogory'}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setFilterVendorCategory("")
                        }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getVendorDetails();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '36.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {textBox("Vendor Name *", 'vendorName', formState?.vendorName, '15vw')}
                        {autoComplete("Vendor Category *", 'vendorCategory', formState?.vendorCategory, vendor_category, '15vw')}
                        {textBox("GSTIN *", 'GSTIN', formState?.GSTIN, '15vw')}
                        {textBox("DL No *", 'DlNo1', formState?.DlNo1, '15vw')}
                        {textBox("DL No", 'DlNo2', formState?.DlNo2, '15vw')}
                        {textBox("DL No", 'DlNo3', formState?.DlNo3, '15vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        {textBox("DL No", 'DlNo4', formState?.DlNo4, '15vw')}
                        {textBox("DL No", 'DlNo5', formState?.DlNo5, '15vw')}
                        {textBox("DL No", 'DlNo6', formState?.DlNo6, '15vw')}
                        {textBox("Mobile No *", 'mobileNum', formState?.mobileNum, '15vw')}
                        {textBox("Landline", 'landline', formState?.landline, '15vw')}
                        {textBox("Email Id *", 'emailId', formState?.emailId, '15vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        {textBox("Address Line 1 *", 'address1', formState?.address1, '30.5vw')}
                        {textBox("Address Line 2", 'address2', formState?.address2, '30.5vw')}
                        {textBox("Area Name *", 'areaName', formState?.areaName, '15vw')}
                        {/* {textBox("City *", 'city', formState?.city, '15vw')} */}
                        {autoComplete("City *", 'city', formState?.city, formState?.cityList, '15vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        {/* {autoComplete("State", 'stateName', formState?.stateName, formState?.AllStates, '15vw')} */}
                        <FormControl size="small" sx={{ width: '15vw',marginRight: '0.3vw' }}>
                            <InputLabel>{`State`}</InputLabel>
                            <Select
                                value={formState.state_code || ''}
                                label={"State"}
                                MenuProps={{
                                    style: { maxHeight: 300, maxWidth: 150 }
                                }}
                                onChange={(e) => {
                                    const cities = City.getCitiesOfState(formState.country_code, e.target.value) || [];
                                    setFormState((prevState) => ({
                                        ...prevState,
                                        // "stateName": val,
                                        "state_code": e.target.value,
                                        "cityList": cities,
                                        "city": "",
                                    }));
                                }}
                            >
                                {State.getStatesOfCountry(formState.country_code)?.map((list) => (
                                    <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl size="small" sx={{ width: '15vw', marginRight: '0.3vw' }}>
                            <InputLabel>{`Country`}</InputLabel>
                            <Select
                                value={formState.country_code || ''}
                                label={"Country"}
                                MenuProps={{
                                    style: { maxHeight: 300, maxWidth: 150 }
                                }}
                                onChange={(e) => {
                                    setFormState((prevState) => ({
                                        ...prevState,
                                        // "country": val,
                                        "state_code": "",
                                        "country_code": e.target.value,
                                        "AllStates": State.getStatesOfCountry(e.target.value),
                                        "city": "",
                                        "cityList": []
                                    }));
                                }}
                            >
                                {Country.getAllCountries()?.map((list) => (
                                    <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {/* {autoComplete("Country", 'country', formState?.country, formState?.AllCountry, '15vw')} */}
                        {textBox("Pincode *", 'pincode', formState?.pincode, '15vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', visibility: 'hidden' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' disabled={!EditID} />} label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction(true) }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} onClick={() => { addVendorDetails() }}>{EditID ? "Update" : "Add"}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '47vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this vendor ?`}
                    AlertNote={"If you remove this vendor, the associated vendor mapping will also be deleted."}
                    deleteAlertPopupClose={closeFilter.bind(this)}
                    removeData={deleteVendor.bind(this)}
                />
                : null}
        </Box>
    )
}
